
import styled from "@emotion/styled";
import { GetPageQuery } from "apollo";
import AccordionFaq from "components/PazClub/AccordionFaq";
import ContainerWrapper from "pazChargeComponents/general/ContainerWrapper";
import { Container, TitleWithLine, extractProperty } from "ui";


type Props = {
    data: GetPageQuery
    noPadding?: boolean
}
const StyledWrapper = styled.div<{ noPadding?: boolean }>`
    padding-top: ${props => props.noPadding ? '40px' : '60px'};
    padding-bottom: ${props => props.noPadding ? '40px' : '60px'};
  ${(props) => props.theme.breakpoints.up("md")} {
    padding-top: ${props => props.noPadding ? '40px' : '80px'};
    padding-bottom: ${props => props.noPadding ? '40px' : '80px'};
  }
`
function QuestionListBlockCharge({ data, noPadding }: Props) {
    const blockTitle = extractProperty(data, "blockTitle")
    const questions: any[] = extractProperty(data, "questions")
    const ContainerComponent = !noPadding ? ContainerWrapper : Container;
    return (
        <ContainerComponent {...(!noPadding ? {} : { padding: 0 })}>
            <StyledWrapper noPadding={noPadding}>
                <TitleWithLine
                    title={blockTitle}
                    titleFontSize={34}
                    desktopFontWeight={500}
                    desktopLineHeight="36px"
                    mobileTitleFontSize={24}
                    titleColor="black"
                    component={"h2"}
                    noMobileMargin
                />
                <AccordionFaq
                    accordion={questions}
                    titleProp="title"
                    contentProp="answer"
                    arrowIconSize={24}
                    titleOverrideStyle={{ desktopFontSize: 18, mobileFontSize: 16, largeDesktopFontSize: 18, mobileLineHeight: "18px", desktopLineHeight: "20px", largeDesktopLineHeight: "20px" }}
                    contenrOverrideStyle={{ desktopFontSize: 18, mobileFontSize: 16, largeDesktopFontSize: 18, mobileLineHeight: "18px", desktopLineHeight: "20px", largeDesktopLineHeight: "20px" }}
                    titleComponent={noPadding ? "h3" : undefined}
                >
                </AccordionFaq>
            </StyledWrapper>
        </ContainerComponent>
    );
}

export default QuestionListBlockCharge;
